<template>
  <div class="category-menu">
    <component :is="hideTitleOnMobile ? 'common-desktop-element' : 'h3'" element="h3" class="category-menu__title">
      <b class="category-menu__title-bold">카테고리</b>에 따라 강의를 찾아보세요.
    </component>
    <ul class="category-menu__list">
      <li v-for="category in normalCategoryList" :key="category.id">
        <a :href="`/${category.titleLink}`" class="category-menu__link">
          <common-category-icon v-if="category.imgUrl" :src="category.imgUrl" large-icon class="category-menu__icon" />
          <span class="category-menu__text">{{ category.title }}</span>
        </a>
      </li>
      <common-mobile-element v-if="showAllCategoryMenu && allCategoryMenu" element="li">
        <a :href="`/${allCategoryMenu.titleLink}`" class="category-menu__link">
          <common-category-icon :src="allCategoryMenu.imgUrl" large-icon class="category-menu__icon" />
          <span class="category-menu__text">전체보기</span>
        </a>
      </common-mobile-element>
    </ul>
  </div>
</template>

<script>
import CommonDesktopElement from '../../common/desktop-element.vue';
import CommonMobileElement from '../../common/mobile-element.vue';
import CommonCategoryIcon from '../../common/category-icon.vue';

import { mainCategoryComponentMixin } from '../../common/mixins';

export default {
  name: 'category-menu',

  mixins: [mainCategoryComponentMixin],

  components: {
    CommonDesktopElement,
    CommonMobileElement,
    CommonCategoryIcon,
  },

  props: {
    categoryList: {
      type: Array,
    },

    hideTitleOnMobile: {
      type: Boolean,
      default: false,
    },

    showAllCategoryMenu: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './category-main';

.category-menu {
  position: relative;
  box-sizing: border-box;
  border-bottom: 0.8rem solid #f2f2f2;

  &__title {
    padding: 0 0 0 1.6rem;

    font-weight: 400;
    font-size: 1.8rem;
    color: #171717;
  }

  &__list {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
  }

  &__link {
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 1.6rem 0 0;

    color: #171717;
  }

  &__icon {
    margin: 0 0 0.4rem;
  }

  &__text {
    font-size: 1.1rem;
    line-height: 2rem;
    text-align: center;
    word-break: keep-all;
  }

  @include mq($until: $large) {
    padding: 0 0 2.4rem;
  }

  @include mq($large) {
    padding: 4rem 1.3rem 3.6rem;
    border: 0.1rem solid #d6d6d6;
    border-radius: 0.6rem;

    &__title {
      position: absolute;
      top: -1.5rem;
      left: -0.1rem;

      padding: 0 2rem 2.5rem 0;

      background-color: #fff;

      line-height: 3rem;
    }

    &__list {
      grid-template-columns: repeat(8, 1fr);
    }

    &__icon {
      transition: transform 100ms cubic-bezier(0.2, 1, 0.8, 1);
    }

    &__link {
      padding: 0.8rem 0 0;

      &:hover {
        color: #ed234b;

        .category-menu__icon {
          transform: translateY(-0.8rem);
        }
      }
    }

    &__text {
      font-size: 1.4rem;
      line-height: 2.4rem;
    }
  }
}
</style>
